export default __webpack_public_path__ + "7f26c3443db42aedc629490b81ce410e.png";